(() => {
  if (customElements.get('ss-product-addon')) return;
  const selections = new Map();
  class SSProductAddon extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.form = document.getElementById(this.dataset.form);
      this.check = this.querySelector('[data-addon-check]');
      if (!this.form || !this.check) return;
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency});
      this.ready = this.dataset.ready === 'true';
      this.stockLimit = Number(this.dataset.stockLimit);
      this.check.disabled = !this.ready;
      this.check.checked = !this.check.disabled && selections.get(this.dataset.form) === true;
      this.check.addEventListener('change', () => { selections.set(this.dataset.form,this.check.checked); this.update(); }, options);
      document.addEventListener('input', event => { if (event.target.form === this.form && event.target.name === 'quantity') this.update(); }, options);
      document.addEventListener('change', event => { if (event.target.form === this.form && event.target.name === 'quantity') this.update(); }, options);
      this.form.addEventListener('variant:change', () => this.update(), options);
      this.form.addEventListener('formdata', event => this.addItems(event.formData), options);
      document.addEventListener('submit', async event => {
        if (event.target !== this.form || !this.check.checked) return;
        if (this.validatedSubmit) { this.validatedSubmit = false; return; }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.validating) return;
        this.validating = true;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('variant', this.form.elements.namedItem('id')?.value || '');
          const response = await fetch(url, {cache:'no-store', signal:this.abort.signal});
          if (!response.ok) throw new Error('Availability check failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = Array.from(page.querySelectorAll('ss-product-addon')).find(el => el.dataset.form === this.dataset.form);
          if (!fresh) throw new Error('Availability response missing');
          this.ready = fresh.dataset.ready === 'true' && fresh.dataset.addonId === this.dataset.addonId;
          this.stockLimit = Number(fresh.dataset.stockLimit);
          this.dataset.ready = String(this.ready);
          this.dataset.stockLimit = String(this.stockLimit);
          this.update();
          if (!this.check.checked) {
            this.notice(this.querySelector('[data-addon-stock-changed]').textContent);
            return;
          }
          this.validatedSubmit = true;
          this.form.requestSubmit(event.submitter || undefined);
        } catch (error) {
          if (error.name !== 'AbortError') this.notice(this.querySelector('[data-addon-check-error]').textContent);
        } finally { this.validating = false; }
      }, {...options,capture:true});
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-addon-open]').addEventListener('click', () => this.dialog.showModal(), options);
      this.querySelector('[data-addon-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.querySelector('[data-addon-open]').focus(), options);
      this.priceObserver = new MutationObserver(() => this.update());
      this.priceObserver.observe(this.querySelector('[data-addon-sources]'), {subtree:true,childList:true,characterData:true});
      const addonPrice = this.querySelector('[data-addon-price]');
      if (addonPrice) this.priceObserver.observe(addonPrice, {subtree:true,childList:true,characterData:true});
      this.update();
      requestAnimationFrame(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() { this.abort?.abort(); this.priceObserver?.disconnect(); }
    price(element, fallback) {
      const amount = element?.querySelector('sale-price') || element;
      const text = amount?.textContent?.trim();
      if (!text) return fallback;
      const digits = text.replace(/[^0-9.,-]/g,'');
      const precision = this.money.resolvedOptions().maximumFractionDigits;
      const decimal = precision && digits.match(new RegExp('[.,](\\d{' + precision + '})$'));
      const number = decimal ? digits.slice(0,decimal.index).replace(/[.,]/g,'') + '.' + decimal[1] : digits.replace(/[.,]/g,'');
      return number && Number.isFinite(Number(number)) ? Math.round(Number(number)*100) : fallback;
    }
    quantity() { return Math.max(1,Math.floor(Number(this.form.elements.namedItem('quantity')?.value) || 1)); }
    notice(text) {
      const notice = this.querySelector('.ss-addon__notice');
      notice.textContent = text;
      notice.hidden = !text;
    }
    update() {
      const quantityAvailable = this.stockLimit < 0 || this.quantity() <= this.stockLimit;
      const selectable = this.ready && quantityAvailable;
      if (!selectable) {
        this.check.checked = false;
        selections.delete(this.dataset.form);
      }
      this.check.disabled = !selectable;
      this.dataset.selectable = String(selectable);
      const status = this.querySelector('[data-addon-status]');
      status.hidden = selectable;
      status.textContent = this.querySelector(this.ready ? '[data-addon-quantity-label]' : (this.dataset.addonId ? '[data-addon-sold-out]' : '[data-addon-unavailable]')).textContent;
      this.querySelector('[data-addon-price-wrap]').hidden = !selectable;
      this.notice(this.ready && !quantityAvailable ? this.querySelector('[data-addon-quantity-unavailable]').textContent : '');
      const selected = this.check.checked;
      const id = this.form.elements.namedItem('id')?.value;
      const source = this.querySelector(`[data-base-variant="${id}"]`);
      const base = this.price(source,NaN);
      const addon = this.price(this.querySelector('[data-addon-price]'), Number(this.dataset.defaultPrice));
      const valid = Number.isFinite(base) && Number.isFinite(addon);
      const summary = this.querySelector('[data-addon-summary]');
      summary.hidden = !selected || !valid;
      if (selected && valid) this.querySelector('[data-addon-total]').textContent = this.money.format((base + addon)*this.quantity()/100);
      this.querySelector('[data-addon-selected]').hidden = !selected;

    }
    addItems(data) {
      if (!this.check.checked || !this.ready) return;
      const id = data.get('id');
      if (!id || !this.dataset.addonId) return;
      data.set('items[0][id]',id);
      data.set('items[0][quantity]',data.get('quantity') || '1');
      const plan = data.get('selling_plan');
      if (plan) data.set('items[0][selling_plan]',plan);
      for (const [key,value] of Array.from(data.entries())) {
        if (key.startsWith('properties[')) { data.append('items[0][properties]'+key.slice(10),value); data.delete(key); }
      }
      data.delete('id'); data.delete('quantity'); data.delete('selling_plan');
      data.set('items[1][id]',this.dataset.addonId);
      data.set('items[1][quantity]',data.get('items[0][quantity]'));
    }
  }
  customElements.define('ss-product-addon',SSProductAddon);
})();

